import css from "./welcomeScreen.module.css";

export function WelcomeScreen() {
  return (
    <div className={css.wrapper}>
      <div className={css.icon}>🍎</div>
    </div>
  );
}
